<template>

	<v-app-bar app flat height="120px" class="header" style="z-index:99">
	
		<v-container fluid class="pa-0">
		
			<v-row class="px-4 appBarH white">
			
				<v-col class="appBarCol" cols="6">
					<v-img v-if="mxnIsLessonDataValid && this.$root.lessonData.organisation.logoUrl" :src="this.$root.lessonData.organisation.logoUrl" alt="logo" contain max-height="100%" position="left" />
					<v-img v-else-if="mxnIsLessonDataValid" src="@/assets/v2k_bildmarke_wortmarke_r_dark.svg" alt="logo" contain max-height="90%" position="left" />
				</v-col>

				<v-col class="appBarCol text-right px-4" cols="6">
					<div v-if="this.$i18n.availableLocales.length > 1" class="d-flex align-center justify-end menuButton">
						<MainMenu />
					</div>
				</v-col>

			</v-row>

			<v-container fluid class="pa-0 appBarH" :class="{ subheading: mxnIsLessonDataValid }">
				<v-container v-show="mxnIsLessonDataValid" appwidth class="py-0 appBarH">
					<v-row class="align-center" style="height:100%">
					
						<v-col class="text-left py-0">
							<v-card-text class="ma-0 pa-0 text">
								{{ this.$root.lessonData.name }}
							</v-card-text>
						</v-col>

					</v-row>
				</v-container>
			</v-container>
		
		</v-container>
	
	</v-app-bar>

</template>

<script>
import MainMenu from '@/components/MainMenu'

export default {
	name: "Header",

	components: {
		MainMenu
	},

	data: () => ({
		//
	}),
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';
	
	::v-deep .v-toolbar__content {
		padding: 0;
	}

	.header {

		.appBarH {
			height: 60px;
		}

		.appBarCol {
			height: inherit;
		}

		.menuButton {
			height: 100%;
		}

		.subheading {
			@include skinColor(background-color, --skinColPrim, $skinColPrim);
			@include skinColor(color, --skinColPrimCompl, $skinColPrimCompl);

			.text {
				font-size: 1.125rem;
				font-weight: 900;
			}
		}
	}

</style>
